// A drawn / placed condition shown on the canvas BEFORE its save has come back (two round trips: the save, then the
// re-read of every drawn row). The row is built from the catalog type the canvas already holds (conditionTypes carries
// the same attribute names sp_GetTakeoffConditionsDrawn returns, this estimate's overrides already applied) plus the
// fields being saved. It is a stand-in: the real re-read replaces the whole list, and a failed save removes it.

// Attributes a drawn row reads from its type — the same names on both sides.
const TYPE_FIELDS = [
  "Code", "Style", "Quantity1CalcType", "Quantity2CalcType", "Quantity3CalcType",
  "Quantity1Unit", "Quantity2Unit", "Quantity3Unit", "DefaultHeightFt", "DefaultWidthFt", "DefaultThicknessIn",
  "Color", "Pattern", "Shape", "SyncsToCriteriaField", "CostCodeID", "CSICode", "CostCodeDescription", "LayerID",
  "GridTileWFt", "GridTileHFt", "GridGapIn", "PatternSpacingIn", "RoundToIn", "RoundAreaToSf",
];

export const isProvisionalId = (id) => typeof id === "number" && id < 0;

export function provisionalConditionRow(typeRow, fields, tempId) {
  const row = {};
  for (const k of TYPE_FIELDS) if (typeRow && typeRow[k] !== undefined) row[k] = typeRow[k];
  row.Name = typeRow?.Name ?? typeRow?.ItemName ?? typeRow?.Description ?? null;
  row.EntityAutoSystem = typeRow?.AutoSystem ?? null;
  return {
    ...row,
    TakeoffConditionDrawnID: tempId,
    RowVer: null,
    TargetType: "drawn",
    DisplayOrder: 100,
    MeasureRole: null,
    ...fields,
    __provisional: true,
  };
}
